export default __webpack_public_path__ + "static/media/ind.5cb9042a.png";